<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
			<div class="dp-dept-hint">
				<span class="dp-dept-hint__label">所属机构</span>
				<span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
			</div>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="NotifyName" label="名称"></el-table-column>
					<el-table-column prop="DepartmentName" label="部门" :formatter="formatDepartmentNameCol" width></el-table-column>
					<el-table-column prop="NotifyDesc" label="描述"></el-table-column>
					<el-table-column prop="EffTime" label="生效日期" :formatter="formatDateTime"></el-table-column>
					<el-table-column prop="ExpTime" label="失效日期" :formatter="formatDateTime"></el-table-column>
					<el-table-column prop="MessageType" label="消息类型">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.MessageType == 1">文本</el-tag>
							<el-tag v-else-if="scope.row.MessageType == 2" type="success">图片</el-tag>
							<el-tag v-else-if="scope.row.MessageType == 3" type="warning">视频</el-tag>
							<el-tag v-else-if="scope.row.MessageType == 4" type="info">外部链接</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="Title" label="标题"></el-table-column>
					<el-table-column prop="HeadPhotoImage" label="媒体文件" align="center" header-align="center" width="200">
						<template slot-scope="scope">
							<div v-if="scope.row.MessageType == 2" class="ss-media-thumbs">
								<oss-media-thumbs
									:media="scope.row.MediaFiles"
									:max="3"
									wrapper-class="ss-media-thumbs"
									img-class="ss-media-thumb"
								/>
							</div>
							<div v-else-if="scope.row.MessageType == 3">
								<span class="video-browse-link"
									style="color:var(--btn-primary, #2563eb);cursor:pointer;text-decoration:underline;"
									@click.stop="handleVideoClick(showImage(scope.row.MediaFiles)[0])">点击浏览</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="ExternalLinks" label="外部链接" width="200">
						<template slot-scope="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.ExternalLinks" placement="top">
								<span class="external-link-ellipsis">
									<a v-if="scope.row.ExternalLinks" :href="scope.row.ExternalLinks" target="_blank"
										:title="scope.row.ExternalLinks">
										{{ scope.row.ExternalLinks }}
									</a>
									<span v-else>—</span>
								</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="LastDuration" label="停留时间(秒)"></el-table-column>
					<el-table-column prop="IsTop" label="是否置顶">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsTop == 1 ? 'success' : 'info'">{{ scope.row.IsTop == 1 ? '是' :
								'否' }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="IsActive" label="是否生效">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsActive == 1 ? 'success' : 'info'">{{ scope.row.IsActive == 1 ?
								'是' : '否' }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="CreateBy" label="创建人"></el-table-column>
					<el-table-column prop="CreateTime" label="创建时间"></el-table-column>
				</el-table>
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!-- 编辑界面 -->
			<el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible"
				:close-on-click-modal="false" @closed="handleEditDialogClose">
				<el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">
					<el-form-item label="名称" prop="NotifyName">
						<el-input v-model="editForm.NotifyName"></el-input>
					</el-form-item>

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader :key="cascaderKey" v-model="editForm.Dids" :options="options" :show-all-levels="false"
							filterable :props="$deptCascaderProps"></el-cascader>
					</el-form-item>
					<el-form-item label="描述" prop="NotifyDesc">
						<el-input v-model="editForm.NotifyDesc"></el-input>
					</el-form-item>
					<el-form-item label="生效日期" prop="EffTime">
						<el-date-picker v-model="editForm.EffTime" type="datetime" placeholder="选择日期时间"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
					</el-form-item>
					<el-form-item label="失效日期" prop="ExpTime">
						<el-date-picker v-model="editForm.ExpTime" type="datetime" placeholder="选择日期时间"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
					</el-form-item>
					<el-form-item label="消息类型" prop="MessageType">
						<el-select v-model="editForm.MessageType" placeholder="请选择">
							<el-option label="文本" :value="1"></el-option>
							<el-option label="图片" :value="2"></el-option>
							<!-- <el-option label="视频" :value="3"></el-option> -->
							<el-option label="外部链接" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="标题" prop="Title">
						<el-input v-model="editForm.Title"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="Content" v-if="editForm.MessageType == 1">
						<quill-editor v-model="editForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>

					<!-- 编辑：图片多图（与班级风采一致，MediaFiles 用 ; 拼接）；视频仍单文件 -->
					<el-form-item label="媒体文件" prop="MediaFiles" v-if="editForm.MessageType == 2">
						<el-upload class="upload-demo" action="#" :auto-upload="false"
							list-type="picture-card" :file-list="EditUploadFiles"
							:on-change="(file, fileList) => onScreenSaverPicChange(file, fileList, 'EditUploadFiles')"
							:on-remove="(file, fileList) => onScreenSaverPicRemove(file, fileList, 'EditUploadFiles')"
							:multiple="false" :limit="9" :on-exceed="handleMediaExceed"
							accept=".png,.jpg,.jpeg,.gif,.bmp,.webp">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="媒体文件" prop="MediaFiles" v-else-if="editForm.MessageType == 3">
						<el-upload class="avatar-uploader" action="#" accept="video/*"
							:show-file-list="false" :http-request="(req) => customScreenSaverMediaUpload(req, 'edit')"
							:before-upload="beforeEditAvatarUpload">
							<video v-if="editMediaPreviewSrc" :src="editMediaPreviewSrc" class="avatar" controls />
							<i v-if="!editImageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
							<i v-if="!editImageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>

					<el-form-item label="外部链接" prop="ExternalLinks" v-if="editForm.MessageType == 4">
						<el-input v-model="editForm.ExternalLinks"></el-input>
					</el-form-item>
					<el-form-item label="停留时间(秒)" prop="LastDuration">
						<el-input v-model="editForm.LastDuration" type="number" min="1"
							@input="onPositiveIntInput('editForm')"></el-input>
					</el-form-item>
					<el-form-item label="是否置顶" prop="IsTop">
						<el-radio-group v-model="editForm.IsTop">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="是否生效" prop="IsActive">
						<el-radio-group v-model="editForm.IsActive">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>
			<!-- 新增界面 -->
			<el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
				@closed="handleAddDialogClose">
				<el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm">
					<el-form-item label="名称" prop="NotifyName">
						<el-input v-model="addForm.NotifyName"></el-input>
					</el-form-item>

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader :key="cascaderKey" v-model="addForm.Dids" :options="options" :show-all-levels="false"
							filterable :props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-form-item label="描述" prop="NotifyDesc">
						<el-input v-model="addForm.NotifyDesc"></el-input>
					</el-form-item>
					<el-form-item label="生效日期" prop="EffTime">
						<el-date-picker v-model="addForm.EffTime" type="datetime" placeholder="选择日期时间"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
					</el-form-item>
					<el-form-item label="失效日期" prop="ExpTime">
						<el-date-picker v-model="addForm.ExpTime" type="datetime" placeholder="选择日期时间"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
					</el-form-item>
					<el-form-item label="消息类型" prop="MessageType">
						<el-select v-model="addForm.MessageType" placeholder="请选择">
							<el-option label="文本" :value="1"></el-option>
							<el-option label="图片" :value="2"></el-option>
							<!-- <el-option label="视频" :value="3"></el-option> -->
							<el-option label="外部链接" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="标题" prop="Title">
						<el-input v-model="addForm.Title"></el-input>
					</el-form-item>
					<!-- 内容：仅文本类型显示 -->
					<el-form-item label="内容" prop="Content" v-if="addForm.MessageType == 1">
						<quill-editor v-model="addForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>

					<!-- 新增：图片多图；视频单文件 -->
					<el-form-item label="媒体文件" prop="MediaFiles" v-if="addForm.MessageType == 2">
						<el-upload class="upload-demo" action="#" :auto-upload="false"
							list-type="picture-card" :file-list="UploadFiles"
							:on-change="(file, fileList) => onScreenSaverPicChange(file, fileList, 'UploadFiles')"
							:on-remove="(file, fileList) => onScreenSaverPicRemove(file, fileList, 'UploadFiles')"
							:multiple="false" :limit="9" :on-exceed="handleMediaExceed"
							accept=".png,.jpg,.jpeg,.gif,.bmp,.webp">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="媒体文件" prop="MediaFiles" v-else-if="addForm.MessageType == 3">
						<el-upload class="avatar-uploader" action="#" accept="video/*"
							:show-file-list="false" :http-request="(req) => customScreenSaverMediaUpload(req, 'add')"
							:before-upload="beforeAddAvatarUpload">
							<video v-if="addMediaPreviewSrc" :src="addMediaPreviewSrc" class="avatar" controls />
							<i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
							<i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>

					<!-- 外部链接：仅外链类型显示 -->
					<el-form-item label="外部链接" prop="ExternalLinks" v-if="addForm.MessageType == 4">
						<el-input v-model="addForm.ExternalLinks"></el-input>
					</el-form-item>
					<el-form-item label="停留时间(秒)" prop="LastDuration">
						<el-input v-model="addForm.LastDuration" type="number" min="1"
							@input="onPositiveIntInput('addForm')"></el-input>
					</el-form-item>
					<el-form-item label="是否置顶" prop="IsTop">
						<el-radio-group v-model="addForm.IsTop">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="是否生效" prop="IsActive">
						<el-radio-group v-model="addForm.IsActive">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<!-- 视频上传进度 -->
			<el-dialog
				title="视频上传中"
				:visible.sync="videoUploading"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				:show-close="false"
				width="400px"
				append-to-body
			>
				<el-progress :percentage="videoUploadProgress" :stroke-width="16"></el-progress>
				<div style="text-align:center;margin-top:12px;color:#909399;font-size:13px;">请勿关闭或切换页面</div>
			</el-dialog>

			<el-upload style="display: none;" name="Files" :data="quillUploadData" class="quill-upload" :on-success="quillSuccess"
				accept=".png, .jpg, .jpeg" :action="BaseApiUrl + '/images/Upload/Pic'">
				<i class="el-icon-upload"></i>
			</el-upload>
			<!-- 放大视频弹窗 -->
			<el-dialog :visible.sync="videoDialogVisible" width="60%" top="5vh" :close-on-click-modal="true" center
				@close="handleVideoDialogClose">
				<video v-if="currentVideoUrl" :src="currentVideoUrl" controls autoplay
					style="width:100%;height:60vh;background:#000"></video>
			</el-dialog>
		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getDeptScreenSaverMessageListPage, editDeptScreenSaverMessage, addDeptScreenSaverMessage, deleteDeptScreenSaverMessage } from '../../api/modules/misc';
import deptCascaderSelectionMixin from '../../mixins/deptCascaderSelectionMixin';
import { BaseApiUrl } from '../../api/base';
import { stripOssPresignParams, buildLocalPicUploadData, normalizeRichTextHtmlForSave, prepareRichTextHtmlForDisplay } from '../../utils/ossMediaUpload'
import {
	attachLocalVideoFile,
	revokeLocalVideoPreview,
	ensureVideoUploaded,
	beginVideoUploadProgress,
	endVideoUploadProgress,
	createVideoUploadProgressHandlers,
} from '../../utils/ossVideoUpload'
import { resolveMediaUrl, resolvePlayableMediaUrl, applyPlayableMediaUrl } from '../../utils/mediaUrl'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	mixins: [deptCascaderSelectionMixin],
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			videoDialogVisible: false,
			currentVideoUrl: '',

			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			quillUploadData: buildLocalPicUploadData('ScreenSaver'),
			searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			imageUrl: '',        // 新增用
			editImageUrl: '',    // 编辑用
			imageLoadding: false,
			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				NotifyName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				Dids: [{ required: true, message: '请选择所属机构', trigger: 'change' }],
				EffTime: [{ required: true, message: '请选择生效日期', trigger: 'change' }],
				ExpTime: [{ required: true, message: '请选择失效日期', trigger: 'change' }],
				// 内容仅文本类型必填
				Content: [
					{
						required: true, message: '请输入内容', trigger: 'blur',
						validator: (rule, value, callback) => {
							if (this.editForm.MessageType == 1 && !value) {
								callback(new Error('请输入内容'));
							} else {
								callback();
							}
						}
					}
				],
				// 媒体文件：图片看 EditUploadFiles；视频认 pendingVideoFile / editImageUrl。最后更新：2026-10-27
				MediaFiles: [
					{
						required: true, message: '请上传媒体文件', trigger: 'change',
						validator: (rule, value, callback) => {
							const mt = this.editForm.MessageType
							if (mt == 3) {
								const hasVideo = this.pendingVideoFile || (value || this.editImageUrl || '').toString().trim()
								if (!hasVideo) callback(new Error('请上传媒体文件'))
								else callback()
								return
							}
							if (mt == 2) {
								if (!(this.EditUploadFiles && this.EditUploadFiles.length)) {
									callback(new Error('请上传媒体文件'))
								} else {
									callback()
								}
								return
							}
							callback()
						}
					}
				],
				// 外部链接仅外链类型必填
				ExternalLinks: [
					{
						required: true, message: '请输入外部链接', trigger: 'blur',
						validator: (rule, value, callback) => {
							if (this.editForm.MessageType == 4 && !value) {
								callback(new Error('请输入外部链接'));
							} else {
								callback();
							}
						}
					}
				],
				LastDuration: [
					{ required: true, message: '请输入停留时间', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (!/^[1-9]\d*$/.test(value)) {
								callback(new Error('请输入正整数'));
							} else {
								callback();
							}
						}, trigger: 'blur'
					}
				],
				IsTop: [{ required: true, message: '请选择是否置顶', trigger: 'change' }],
				IsActive: [{ required: true, message: '请选择是否生效', trigger: 'change' }],

			},
			//编辑界面数据
			editForm: {
				Id: 0,
				DepartmentId: '',         // 部门ID
				Dids: [],                 // 所属机构（级联选择用）
				NotifyName: '',           // 名称
				NotifyDesc: '',           // 描述
				EffTime: '',              // 生效日期
				ExpTime: '',              // 失效日期
				MessageType: 1,           // 消息类型，默认文本
				Title: '',                // 标题
				Content: '',              // 内容（富文本）
				MediaFiles: '',           // 媒体文件
				ExternalLinks: '',        // 外部链接
				LastDuration: '',         // 停留时间(秒)
				IsTop: 0,                 // 是否置顶
				IsActive: 1,              // 是否生效
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				NotifyName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				Dids: [{ required: true, message: '请选择所属机构', trigger: 'change' }],
				EffTime: [{ required: true, message: '请选择生效日期', trigger: 'change' }],
				ExpTime: [{ required: true, message: '请选择失效日期', trigger: 'change' }],
				Content: [
					{
						required: true, message: '请输入内容', trigger: 'blur',
						validator: (rule, value, callback) => {
							if (this.addForm.MessageType == 1 && !value) {
								callback(new Error('请输入内容'));
							} else {
								callback();
							}
						}
					}
				],
				MediaFiles: [
					{
						required: true, message: '请上传媒体文件', trigger: 'change',
						validator: (rule, value, callback) => {
							const mt = this.addForm.MessageType
							if (mt == 3) {
								const hasVideo = this.pendingVideoFile || (value || this.imageUrl || '').toString().trim()
								if (!hasVideo) callback(new Error('请上传媒体文件'))
								else callback()
								return
							}
							if (mt == 2) {
								if (!(this.UploadFiles && this.UploadFiles.length)) {
									callback(new Error('请上传媒体文件'))
								} else {
									callback()
								}
								return
							}
							callback()
						}
					}
				],
				ExternalLinks: [
					{
						required: true, message: '请输入外部链接', trigger: 'blur',
						validator: (rule, value, callback) => {
							if (this.addForm.MessageType == 4 && !value) {
								callback(new Error('请输入外部链接'));
							} else {
								callback();
							}
						}
					}
				],
				LastDuration: [
					{ required: true, message: '请输入停留时间', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (!/^[1-9]\d*$/.test(value)) {
								callback(new Error('请输入正整数'));
							} else {
								callback();
							}
						}, trigger: 'blur'
					}
				],
				IsTop: [{ required: true, message: '请选择是否置顶', trigger: 'change' }],
				IsActive: [{ required: true, message: '请选择是否生效', trigger: 'change' }],

			},
			//新增界面数据
			addForm: {
				Dids: [],                 // 所属机构（级联选择用）
				NotifyName: '',           // 名称
				NotifyDesc: '',           // 描述
				EffTime: '',              // 生效日期
				ExpTime: '',              // 失效日期
				MessageType: 1,           // 消息类型，默认文本
				Title: '',                // 标题
				Content: '',              // 内容（富文本）
				MediaFiles: '',           // 媒体文件
				ExternalLinks: '',        // 外部链接
				LastDuration: '',         // 停留时间(秒)
				IsTop: 0,                 // 是否置顶
				IsActive: 1,              // 是否生效
			},
			DepartmentId: 0,
			SchoolId: 0,
			multipleSelection: [],
			currentDepartmentName: '',
			pendingVideoFile: null,
			pendingVideoPreviewUrl: '',
			addVideoPlaySrc: '',
			editVideoPlaySrc: '',
			videoUploading: false,
			videoUploadProgress: 0,
			UploadFiles: [],     // 新增图片（多图）
			EditUploadFiles: [], // 编辑图片（多图）
		}
	},
	computed: {
		addMediaPreviewSrc() {
			if (this.addForm.MessageType !== 3) return this.resolveMediaUrl(this.imageUrl)
			if (this.pendingVideoPreviewUrl) return this.pendingVideoPreviewUrl
			return this.addVideoPlaySrc || this.resolveMediaUrl(this.imageUrl)
		},
		editMediaPreviewSrc() {
			if (this.editForm.MessageType !== 3) return this.resolveMediaUrl(this.editImageUrl)
			if (this.pendingVideoPreviewUrl) return this.pendingVideoPreviewUrl
			return this.editVideoPlaySrc || this.resolveMediaUrl(this.editImageUrl)
		},
	},
	methods: {
		resolveMediaUrl,
		/** 弹窗关闭：清理多图本地预览与待上传视频 */
		handleEditDialogClose() {
			this.deferredPictureCardClear('EditUploadFiles')
			this.revokePendingVideoLocal()
		},
		handleAddDialogClose() {
			this.deferredPictureCardClear('UploadFiles')
			this.revokePendingVideoLocal()
		},
		handleMediaExceed() {
			this.$message.warning('最多上传9张图片')
		},
		/** 多图选择后触发 MediaFiles 校验 */
		onScreenSaverPicChange(file, fileList, targetListKey) {
			this.deferredPictureCardChange(file, fileList, targetListKey)
			const formRef = targetListKey === 'EditUploadFiles' ? 'editForm' : 'addForm'
			this.$nextTick(() => {
				if (this.$refs[formRef]) this.$refs[formRef].validateField('MediaFiles')
			})
		},
		onScreenSaverPicRemove(file, fileList, targetListKey) {
			this.deferredPictureCardRemove(file, fileList, targetListKey)
			const formRef = targetListKey === 'EditUploadFiles' ? 'editForm' : 'addForm'
			this.$nextTick(() => {
				if (this.$refs[formRef]) this.$refs[formRef].validateField('MediaFiles')
			})
		},
		async refreshAddVideoPlaySrc() {
			if (this.addForm.MessageType !== 3 || this.pendingVideoPreviewUrl) {
				this.addVideoPlaySrc = ''
				return
			}
			await applyPlayableMediaUrl(this, 'addVideoPlaySrc', this.imageUrl, this.DepartmentId)
		},
		async refreshEditVideoPlaySrc() {
			if (this.editForm.MessageType !== 3 || this.pendingVideoPreviewUrl) {
				this.editVideoPlaySrc = ''
				return
			}
			await applyPlayableMediaUrl(this, 'editVideoPlaySrc', this.editImageUrl, this.DepartmentId)
		},
		/** 视频媒体延迟上传（图片改走 picture-card）。最后更新：2026-10-27 */
		async customScreenSaverMediaUpload(req, mode) {
			const { file, onSuccess, onError } = req
			const isEdit = mode === 'edit'
			if (!this.DepartmentId) {
				this.$message.warning('请先选择部门')
				onError(new Error('未选择部门'))
				this.imageLoadding = false
				return
			}
			try {
				this.revokePendingVideoLocal()
				const local = attachLocalVideoFile(file)
				this.pendingVideoFile = local.pendingVideoFile
				this.pendingVideoPreviewUrl = local.pendingVideoPreviewUrl
				if (isEdit) {
					this.editImageUrl = this.pendingVideoPreviewUrl
					if (this.$refs.editForm) this.$refs.editForm.validateField('MediaFiles')
				} else {
					this.imageUrl = this.pendingVideoPreviewUrl
					if (this.$refs.addForm) this.$refs.addForm.validateField('MediaFiles')
				}
				this.imageLoadding = false
				onSuccess({ success: true, response: '' })
			} catch (e) {
				this.imageLoadding = false
				this.$message.error((e && e.message) || '上传失败')
				onError(e)
			}
		},
		revokePendingVideoLocal() {
			revokeLocalVideoPreview(this.pendingVideoPreviewUrl)
			this.pendingVideoFile = null
			this.pendingVideoPreviewUrl = ''
			this.addVideoPlaySrc = ''
			this.editVideoPlaySrc = ''
		},
		handleVideoDialogClose() {
			this.currentVideoUrl = '';
		},
		formatDateTime(row, column, cellValue) {
			if (!cellValue) return '';
			return util.formatDate.format(new Date(cellValue), 'yyyy-MM-dd hh:mm:ss');
		},

		async handleVideoClick(videoPath) {
			if (!videoPath) return
			try {
				this.currentVideoUrl = await resolvePlayableMediaUrl(videoPath, this.DepartmentId)
			} catch (e) {
				this.$message.error((e && e.message) || '无法播放视频')
				return
			}
			this.videoDialogVisible = true
		},

		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.captureDepartmentTreeContext(data, node)
			this.currentDepartmentName = data.label || data.name || ''
			// 向上寻找当前节点所属的学校ID
			let schoolId = 0;
			let tempNode = node;
			while (tempNode) {
				if (tempNode.data && (tempNode.data.DeptOrgType === 'school' || tempNode.data.DeptOrgType === 'affiliateschool')) {
					schoolId = tempNode.data.value;
					break;
				}
				if (tempNode !== node || tempNode.level === 1) {
					if (tempNode.level === 2 || tempNode.level === 1) {
						schoolId = tempNode.data.value;
						break;
					}
				}
				tempNode = tempNode.parent;
			}
			this.SchoolId = schoolId || data.value;
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				type: 1,
				departmentId: this.DepartmentId,
			}
			getDeptScreenSaverMessageListPage(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				type: 1,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getDeptScreenSaverMessageListPage(para).then(async (res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				const rows = res.data.response.data || []
				await this.prefetchListOssMedia(rows, 'MediaFiles')
				this.users = rows
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//显示编辑界面
		async handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			this.revokePendingVideoLocal()
			this.deferredPictureCardClear('EditUploadFiles')
			this.editForm = Object.assign({}, row[0])
			if (this.editForm.Content) {
				this.editForm.Content = prepareRichTextHtmlForDisplay(this.editForm.Content, this.BaseApiUrl)
			}
			if (this.editForm.Dids) {
				this.$set(this.editForm, 'Dids', this.sanitizeDeptCascaderIds(this.editForm.Dids));
			} else {
				this.$set(this.editForm, 'Dids', []);
			}
			this.editForm.MessageType = Number(this.editForm.MessageType)
			// 图片：多图回显；视频：单路径预览
			if (this.editForm.MessageType === 2) {
				this.editImageUrl = ''
				this.EditUploadFiles = await this.deferredPictureCardFromMedia(this.editForm.MediaFiles)
			} else if (this.editForm.MessageType === 3) {
				const mediaPaths = this.showImage(this.editForm.MediaFiles)
				this.editImageUrl = (mediaPaths && mediaPaths[0]) || ''
			} else {
				this.editImageUrl = ''
			}
			this.editFormVisible = true
			this.$nextTick(() => {
				if (this.editForm.MessageType === 3) this.refreshEditVideoPlaySrc()
			})
			this.options = []
			this.initDeptFormSelection('edit', row[0].DepartmentId, row[0].Dids).then((path) => {
				this.applyDeptCascaderPath(this.editForm, path)
			}).catch(() => {})
		},
		//显示新增界面
		handleAdd() {
			if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
				this.$message.warning("请先在左侧选择具体的学校机构！");
				return;
			}
			if (!this.getSchoolIdForDeptCascader()) {
				this.$message.warning("请先在顶部切换学校！");
				return;
			}
			this.revokePendingVideoLocal()
			this.deferredPictureCardClear('UploadFiles')
			this.addForm = {
				Dids: [],                 // 所属机构（级联选择用）
				NotifyName: '',           // 名称
				NotifyDesc: '',           // 描述
				EffTime: '',              // 生效日期
				ExpTime: '',              // 失效日期
				MessageType: 1,           // 消息类型，默认文本
				Title: '',                // 标题
				Content: '',              // 内容（富文本）
				MediaFiles: '',           // 媒体文件
				ExternalLinks: '',        // 外部链接
				LastDuration: '',         // 停留时间(秒)
				IsTop: 0,                 // 是否置顶
				IsActive: 1,              // 是否生效
			}
			this.imageUrl = ''
			this.options = []
			this.initDeptFormSelection('add', this.DepartmentId).then((path) => {
				this.addFormVisible = true
				this.applyDeptCascaderPath(this.addForm, path)
			}).catch(() => {})
		},
		quillSuccess(response) {
			if (!response.success) {
				this.$message({
					message: response.msg,
					type: 'error',
				})
				return
			}
			const editorRef = this.$refs.myQuillEditor
			const editor = Array.isArray(editorRef) ? editorRef.find((e) => e && e.quill) : editorRef
			const quill = editor && editor.quill
			if (!quill) {
				this.$message.error('编辑器未就绪')
				return
			}
			const range = quill.getSelection()
			const pos = range ? range.index : quill.getLength()
			const stablePath = stripOssPresignParams(response.response)
			quill.insertEmbed(pos, 'image', this.$resolveImageSrc(stablePath))
		},
		normalizeContentForSave(form) {
			if (!form || form.Content == null) return
			form.Content = normalizeRichTextHtmlForSave(form.Content, this.BaseApiUrl)
		},
		beforeAddAvatarUpload(file) {
			if (this.addForm.MessageType == 3) {
				const isMp4 = file.type === 'video/mp4';
				if (!isMp4) {
					this.$message.error('只能上传MP4格式的视频文件！');
					return false;
				}
				const isLt100M = file.size / 1024 / 1024 < 100
				if (!isLt100M) {
					this.$message.error('上传视频大小不能超过 100MB!')
					return false
				}
			}
			this.imageLoadding = true;
			return true;
		},
		beforeEditAvatarUpload(file) {
			if (this.editForm.MessageType == 3) {
				const isMp4 = file.type === 'video/mp4';
				if (!isMp4) {
					this.$message.error('只能上传MP4格式的视频文件！');
					return false;
				}
				const isLt100M = file.size / 1024 / 1024 < 100
				if (!isLt100M) {
					this.$message.error('上传视频大小不能超过 100MB!')
					return false
				}
			}
			this.imageLoadding = true;
			return true;
		},

		//编辑
		editSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待媒体上传完成')
				return
			}
			if (this.editForm.MessageType === 2 && !(this.EditUploadFiles && this.EditUploadFiles.length)) {
				this.$message.error('请上传图片')
				return
			}
			if (this.editForm.MessageType === 3) {
				const hasVideo = this.pendingVideoFile || (this.editImageUrl || this.editForm.MediaFiles || '').trim()
				if (!hasVideo) {
					this.$message.error('请选择视频文件')
					return
				}
			}
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.editLoading = true
						try {
							if (this.editForm.MessageType === 2) {
								const mediaUrls = await this.deferredPictureCardEnsure(this.EditUploadFiles, 'ScreenSaver')
								this.editForm.MediaFiles = mediaUrls.join(';')
							} else if (this.editForm.MessageType === 3) {
								if (this.pendingVideoFile) {
									beginVideoUploadProgress(this)
									try {
										this.editImageUrl = await ensureVideoUploaded(
											this.DepartmentId,
											this.pendingVideoFile,
											this.editImageUrl || this.editForm.MediaFiles,
											'ScreenSaver',
											createVideoUploadProgressHandlers(this)
										)
										this.revokePendingVideoLocal()
										await this.refreshEditVideoPlaySrc()
									} finally {
										endVideoUploadProgress(this)
									}
								}
								this.editForm.MediaFiles = this.editImageUrl
							} else {
								this.editForm.MediaFiles = ''
							}
						} catch (e) {
							this.editLoading = false
							this.$message.error((e && e.message) || '媒体上传失败')
							return
						}
						this.normalizeContentForSave(this.editForm)
						let para = Object.assign({}, this.editForm)
						para.DepartmentId = para.Dids.pop();
						editDeptScreenSaverMessage(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
								this.editLoading = false
							}
						})
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待媒体上传完成')
				return
			}
			if (this.addForm.MessageType === 2 && !(this.UploadFiles && this.UploadFiles.length)) {
				this.$message.error('请上传图片')
				return
			}
			if (this.addForm.MessageType === 3) {
				const hasVideo = this.pendingVideoFile || (this.imageUrl || this.addForm.MediaFiles || '').trim()
				if (!hasVideo) {
					this.$message.error('请选择视频文件')
					return
				}
			}
			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.addLoading = true
						try {
							if (this.addForm.MessageType === 2) {
								const mediaUrls = await this.deferredPictureCardEnsure(this.UploadFiles, 'ScreenSaver')
								this.addForm.MediaFiles = mediaUrls.join(';')
							} else if (this.addForm.MessageType === 3) {
								if (this.pendingVideoFile) {
									beginVideoUploadProgress(this)
									try {
										this.imageUrl = await ensureVideoUploaded(
											this.DepartmentId,
											this.pendingVideoFile,
											this.imageUrl || this.addForm.MediaFiles,
											'ScreenSaver',
											createVideoUploadProgressHandlers(this)
										)
										this.revokePendingVideoLocal()
										await this.refreshAddVideoPlaySrc()
									} finally {
										endVideoUploadProgress(this)
									}
								}
								this.addForm.MediaFiles = this.imageUrl
							} else {
								this.addForm.MediaFiles = ''
							}
						} catch (e) {
							this.addLoading = false
							this.$message.error((e && e.message) || '媒体上传失败')
							return
						}
						this.normalizeContentForSave(this.addForm)
						let para = Object.assign({}, this.addForm)
						para.DepartmentId = para.Dids.pop();
						var user = JSON.parse(window.localStorage.user)
						if (user && user.uID > 0) {
							para.CreateUser = user.uRealName
						} else {
							this.$message({
								message: '用户信息为空，先登录',
								type: 'error',
							})
							_this.$router.replace(
								_this.$route.query.redirect ? _this.$route.query.redirect : '/'
							)
						}

						addDeptScreenSaverMessage(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}

							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
								this.addLoading = false
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})

				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteDeptScreenSaverMessage(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		onPositiveIntInput(formName) {
			let val = this[formName].LastDuration;
			// 只保留正整数
			this[formName].LastDuration = val.replace(/[^0-9]/g, '').replace(/^0+/, '');
		},
		// 格式化部门名称：只保留路径的最后两级
		formatDepartmentNameCol(row, column, cellValue) {
			if (!cellValue) return '';
			const parts = cellValue.split('/');
			if (parts.length > 2) {
				return parts.slice(-2).join('/');
			}
			return cellValue;
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}

/* 列表「媒体文件」列：横向缩略图，限制行高 */
.ss-media-thumbs {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: center;
	gap: 4px;
	max-height: 56px;
	overflow: hidden;
}

.ss-media-thumb {
	width: 52px;
	height: 52px;
	object-fit: cover;
	border-radius: 4px;
	cursor: pointer;
	flex-shrink: 0;
}

.ss-media-more {
	font-size: 12px;
	font-weight: 600;
	color: #909399;
	line-height: 52px;
	flex-shrink: 0;
}
</style>
